<template>
  <v-container grid-list-xl class="pa-0" v-if="laporan">
    <m-breadcrum class="mt-5 mb-0" :items="bread"></m-breadcrum>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <MChartPie title="Jenis Kelamin" :op-data="gender.data" :op-legend="gender.legend" />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <MChartPie title="Jenis Anggota" :op-data="jenis_anggota.data" :op-legend="jenis_anggota.legend" />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <MChartPie title="Usia" :op-data="usia.data" :op-legend="usia.legend" />
      </v-col>
    </v-row>
    <v-row wrap v-if="detail">
<!--      <v-col cols="12" sm="6" md="4" lg="3" xl="3">-->
<!--        <BlockCard title="Jumlah DPC Lolos" :value="detail.dpc_lolos" icon="mdi-file" color="#FBC02D" />-->
<!--      </v-col>-->
<!--      <v-col cols="12" sm="6" md="4" lg="3" xl="3">-->
<!--        <BlockCard title="Persentase DPC Lolos" :value="detail.persen_dpc_lolos" icon="mdi-file-percent" color="#4DB6AC" />-->
<!--      </v-col>-->
      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <BlockCard title="TOTAL MS" :value="detail.dpc_ms" icon="mdi-file" color="#EC407A" />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <BlockCard title="% TOTAL MS" :value="detail.persen_dpc_ms" icon="mdi-file-percent" color="#EA80FC" />
      </v-col>
    </v-row>
    <m-card title="Laporan Rekap Propinsi" @download="toDowload">
      <v-simple-table id="rekap">
        <template v-slot:default>
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Kota</th>
              <th>Syarat Minimal</th>
              <th>STATUS</th>
              <th>Total MS Vermin</th>
              <th>Sampel</th>
              <th>Minimal Sampel MS</th>
              <th>PREDIKSI MS</th>
              <th>% CAPAIAN MS</th>
              <th>PREDIKSI STATUS</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in laporan.list" :key="item.index">
              <td class="text-center">{{ index + 1 }}</td>
              <td>
                <router-link
                  class="primary--text font-weight-bold"
                  :to="{
                    name: 'laporan.kota',
                    params: {
                      propinsi_id: item.propinsi_id,
                      kota_id: item.id
                    }
                  }"
                  >{{ pVal(item, "keterangan") }}
                </router-link>
              </td>
              <td class="text-center">{{ item.a_syarat_minimal }}</td>
              <td class="text-center">{{ item.a_status }}</td>
              <td class="text-center">{{ item.a_total_ms_vermin }}</td>
              <td class="text-center">{{ item.a_sampel }}</td>
              <td class="text-center">{{ item.a_minimal }}</td>
              <td class="text-center">{{ item.a_prediksi_ms }}</td>
              <td class="text-center">{{ item.capaian }}</td>
              <td class="text-center">{{ item.prediksi_status }}</td>
<!--              <td class="text-center">{{ item.status_verfak }}</td>-->
<!--              <td class="text-center">{{ item.kekurangan_verfak }}</td>-->
<!--              <td class="text-center">{{ item.total_perbaikan }}</td>-->
<!--              <td class="text-center">{{ item.cadangan }}</td>-->
<!--              <td class="text-center">{{ item.minimal_ms }}</td>-->
<!--              <td class="text-center">{{ item.sample_ms }}</td>-->
<!--              <td class="text-center">{{ item.potensi_ms }}</td>-->
            </tr>
          </tbody>
          <tfoot class="grey lighten-1">
            <td colspan="2" class="text-center font-weight-bold">Total</td>
            <td class="text-center font-weight-bold">{{ laporan.total }}</td>
            <td class="text-center font-weight-bold"></td>
            <td class="text-center font-weight-bold"></td>
            <td class="text-center font-weight-bold"></td>
            <td class="text-center font-weight-bold"></td>
            <td class="text-center font-weight-bold"></td>
          </tfoot>
        </template>
      </v-simple-table>
    </m-card>
  </v-container>
</template>

<script>
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
import MChartPie from "@/components/MChartPie";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    MChartPie,
    BlockCard
  },
  data() {
    return {
      gender: {
        legend: [],
        data: []
      },
      jenis_anggota: {
        legend: [],
        data: []
      },
      usia: {
        legend: [],
        data: []
      },
      laporan: {
        list: []
      },
      countWarga: 0,
      propinsi_ket: "",
      detail: null
    };
  },
  mounted() {
    this.load();
    this.loadKeteranganPropinsi();
    this.loadStatistik();
  },
  methods: {
    load() {
      return this.$store
        .dispatch("laporan/rekapPropinsi", {
          params: { propinsi_id: this.propinsi_id }
        })
        .then(res => {
          this.laporan = res;
          res.forEach(item => {
            this.countWarga = this.countWarga + item.warga_count;
          });
        })
        .catch(e => e);
    },
    loadStatistik() {
      this.$store
        .dispatch("laporan/statistikPropinsi", {
          params: { propinsi_id: this.propinsi_id }
        })
        .then(res => {
          this.gender.legend = ["L : " + res.kelamin.pria, "P : " + res.kelamin.wanita];
          this.gender.data = [
            {
              value: res.kelamin.pria,
              name: "L : " + res.kelamin.pria
            },
            {
              value: res.kelamin.wanita,
              name: "P : " + res.kelamin.wanita
            }
          ];
          this.jenis_anggota.legend = [
            "Anggota : " + res.jenis_anggota.Anggota,
            "Ranting : " + res.jenis_anggota.Ranting,
            "PAC : " + res.jenis_anggota.PAC,
            "DPC : " + res.jenis_anggota.DPC,
            "DPW : " + res.jenis_anggota.DPW,
            "DPP : " + res.jenis_anggota.DPP
          ];
          this.jenis_anggota.data = [
            {
              value: res.jenis_anggota.Anggota,
              name: "Anggota : " + res.jenis_anggota.Anggota
            },
            {
              value: res.jenis_anggota.Ranting,
              name: "Ranting : " + res.jenis_anggota.Ranting
            },
            {
              value: res.jenis_anggota.PAC,
              name: "PAC : " + res.jenis_anggota.PAC
            },
            {
              value: res.jenis_anggota.DPC,
              name: "DPC : " + res.jenis_anggota.DPC
            },
            {
              value: res.jenis_anggota.DPW,
              name: "DPW : " + res.jenis_anggota.DPW
            },
            {
              value: res.jenis_anggota.DPP,
              name: "DPP : " + res.jenis_anggota.DPP
            }
          ];
          this.usia.legend = ["0-25 Thn : " + res.usia.usia_0_sampai_25_tahun, "26-40 Thn : " + res.usia.usia_26_sampai_40_tahun, ">40 Thn : " + res.usia.usia_lebih_40_tahun];
          this.usia.data = [
            {
              value: res.usia.usia_0_sampai_25_tahun,
              name: "0-25 Thn : " + res.usia.usia_0_sampai_25_tahun
            },
            {
              value: res.usia.usia_26_sampai_40_tahun,
              name: "26-40 Thn : " + res.usia.usia_26_sampai_40_tahun
            },
            {
              value: res.usia.usia_lebih_40_tahun,
              name: ">40 Thn : " + res.usia.usia_lebih_40_tahun
            }
          ];
        });
    },
    loadKeteranganPropinsi() {
      return this.$store
        .dispatch("laporan/keteranganPropinsi", this.propinsi_id)
        .then(res => {
          this.detail = res;
          this.propinsi_ket = res.keterangan;
        })
        .catch(e => e);
    },
    toDowload() {
      var token = lc.getItem(TOKEN);

      return this.$store
        .dispatch("laporan/download", {
          token: token,
          params: {
            propinsi_id: this.propinsi_id,
            kota_id: this.kota_id,
            kecamatan_id: this.kecamatan_id
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    propinsi_id(n) {
      this.loadKeteranganPropinsi(n);
      if (n) {
        this.load();
        this.loadStatistik();
      }
    }
  },
  computed: {
    bread() {
      return [
        {
          icon: "mdi-library-books",
          title: "Rekap Pusat",
          to: this.current_user.lingkup.tingkat == 1 ? { name: "laporan.pusat" } : null
        },
        {
          icon: "mdi-library-books",
          title: this.propinsi_ket
        }
      ];
    }
  }
};
</script>
<style>
#rekap {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#rekap td,
#rekap th {
  border: 1px solid #ddd;
  padding: 8px;
}

#rekap tr:nth-child(even) {
  background-color: #f2f2f2;
}

#rekap tr:hover {
  background-color: #ddd;
}

#rekap th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #4caf50;
  color: white;
}
</style>
